import type { ComponentStyleConfig } from '@chakra-ui/react';

import * as variants from '../typography';

const TextComponentStyle: ComponentStyleConfig = {
  variants: {
    ...variants,
    bodySmall: {
      fontSize: '12px',
    },
  },
  defaultProps: {
    variant: 'paragraph',
  },
};

export default TextComponentStyle;
